export default function (action) {
  return action['@@redux-saga/SAGA_ACTION'];
}
